module.exports = __webpack_public_path__ + "static/media/cube-open.83d4d04b.svg";